import api from './api';

export const benefitService = {
  /**
   * Get all form data needed to render the benefit form.
   */
  getFormData: async () => {
    const response = await api.get('/benefit/form-data');
    return response.data;
  },

  /**
   * Calculate tier/discount based on income inputs.
   */
  calculateTier: async (data) => {
    const response = await api.post('/benefit/calculate-tier', data);
    return response.data;
  },

  /**
   * Calculate grant based on arrears liability amount.
   */
  calculateGrant: async (data) => {
    const response = await api.post('/benefit/calculate-grant', data);
    return response.data;
  },

  /**
   * Recalculate grant based on arrearage and arrears liability amount.
   */
  recalculateGrant: async (data) => {
    const response = await api.post('/benefit/recalculate-grant', data);
    return response.data;
  },

  /**
   * Create a new benefit.
   */
  createBenefit: async (formData) => {
    const response = await api.post('/benefit/create', formData);
    return response.data;
  },
};